// src/config.js
export const IMAGE_BASE_URL = '/images';
export const IMAGE_PATHS = {
  Tires: `${IMAGE_BASE_URL}/tires.png`,
  Suspension: `${IMAGE_BASE_URL}/suspension.png`,
  Brakes: `${IMAGE_BASE_URL}/brakes.png`,
  Aero: `${IMAGE_BASE_URL}/aero.png`,
  Drivetrain: `${IMAGE_BASE_URL}/drivetrain.png`,
  Engine: `${IMAGE_BASE_URL}/engine.png`,
  Electronics: `${IMAGE_BASE_URL}/electronics.png`,
  Info: `${IMAGE_BASE_URL}/infotab.png`, // Added Info tab image
};

export const SW_VERSION = '1.0.0';

export const OPENWEATHER_API_KEY = '0b6b34aeceae9fce943718740400c55c'; // Get your free API key from https://openweathermap.org/api